const wrapper = document.querySelector(".is-wrapper");
const navigationTop = document.querySelector("nav.top");
const footerHeight = document.querySelector("footer");

function calculateWrapper() {
    const windowHeight = window.innerHeight;
    const minHeight = windowHeight - navigationTop.offsetHeight - footerHeight.offsetHeight;
    
    wrapper.style.minHeight = minHeight + 'px';
}

function adjustScrollPaddingTop() {
    const navigationPosition = getComputedStyle(navigationTop).position;
    
    if(navigationPosition !== "fixed") {
        return;
    }
    
    //document.documentElement er html elementet
    document.documentElement.style.scrollPaddingTop = navigationTop.offsetHeight + 'px';
}

if(wrapper && navigationTop) {
    calculateWrapper();
    window.addEventListener('resize', () => calculateWrapper());
}

if(navigationTop) {
    adjustScrollPaddingTop();
    window.addEventListener('resize', () => adjustScrollPaddingTop());
}


